/**
 * @title membership-validation.js: Sub-module of Register User (Create Account) page
 * @description This module provides membership validation functionality.
 * @dependency
 */
define([], function() {
  let MembershipValidation = {

    /**
     * Initializes the submodule data
     * @return void
     */
    init: function() {
      this.maskInputs();
      this.bindEvents();
    	  COSTCO.util.maskMembershipInput();
      
      $('#AddMembershipForm').keypress(function (e) {
        if (e.which == 13) {
          MembershipValidation.addMembershipForm.submitForm()
        }
      });
     },

    /**
     * Binds event handlers
     * @return void
     */
    bindEvents: function() {
      $('#buy-membership-button').unbind('click').bind('click', function() {
        if ($.cookie('cartCountCookie') > 0) {
          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
        } else {
          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
        }
      });
    },

    /**
     * Calls renew membership main logic
     * @param  {String}  membershipType membership type
     * @param  {Boolean} isExecutive    true | false
     * @param  {Boolean} isUpgrade      true | false
     * @param  {String} fromPage       source page to decide on redirection
     * @return void
     */
    renewMembership: function(memberType, isExecutive, isUpgrade, fromPage) {
		
		    var goldDiv = document.getElementById('membership-config-gold');
        var uccGoldEnabled = goldDiv ? goldDiv.getAttribute('data-ucc-renew-upgrade-gold-enabled') : "false";
        var busDiv = document.getElementById('membership-config-bus');
        var uccBusinessEnabled = busDiv ? busDiv.getAttribute('data-ucc-renew-upgrade-business-enabled') : "false";
        
        let uccGold = "true";
        let uccBusiness = "true";
     
        let addRenewMemberhsipToCartUrl = '';
        // Check if MembershipRenewUpgradeStatic object exists (provided externally from JSP)
        if (typeof MembershipRenewUpgradeStatic == 'object') {
          if (memberType.toUpperCase() == 'Z010') {
            addRenewMemberhsipToCartUrl = (isExecutive || isUpgrade) ? MembershipRenewUpgradeStatic.goldExecRenewAddToCart : MembershipRenewUpgradeStatic.goldBasicRenewAddToCart;
			 uccGold = uccGoldEnabled;  
          } else if (memberType.toUpperCase() == 'Z020') {
            addRenewMemberhsipToCartUrl = (isExecutive || isUpgrade) ? MembershipRenewUpgradeStatic.bizExecRenewAddToCart : MembershipRenewUpgradeStatic.bizBasicRenewAddToCart;
			uccBusiness = uccBusinessEnabled;
          } else {
            console.error('Unsupported membership type');
          }
          if(fromPage && fromPage !== '' ){
        	  addRenewMemberhsipToCartUrl = addRenewMemberhsipToCartUrl + '&sourcePage='+ fromPage; 
          }
          
          if (typeof dmcRenwalFlow != "undefined" ? dmcRenwalFlow : false) {
        	  addRenewMemberhsipToCartUrl += '&dmcRenewalFlow=true&deviceId=' + deviceId;
          }
		  
		  	
			
			
           if(uccGold === "true" && uccBusiness === "true"){
        	
		    	// Try to get cardNumber from membershipData first, then fall back to memberData
        	  if(membershipData != null && membershipData !== 'undefined' ){
        	    const cardNumber = membershipData.caller.cardNumber.value;
	      	    const queryString = addRenewMemberhsipToCartUrl.split('?')[1];
	            const params = new URLSearchParams(queryString);
	            const itemNumber = params.get('itemNumber');
	        
	            localStorage.setItem(
	        	    'cartMember',
	        	    JSON.stringify({ id: cardNumber})
	        	);
               
	            window.location.href = '/cart/membership/terms?itemNumber='+encodeURIComponent(itemNumber);
			 } else if(typeof memberData !== 'undefined' && memberData != null && memberData.caller && memberData.caller.cardNumber){
			    const cardNumber = memberData.caller.cardNumber.value;
	      	    const queryString = addRenewMemberhsipToCartUrl.split('?')[1];
	            const params = new URLSearchParams(queryString);
	            const itemNumber = params.get('itemNumber');
	        
	        localStorage.setItem(
	        	    'cartMember',
	        	    JSON.stringify({ id: cardNumber})
	        	  );
               
	        window.location.href = '/cart/membership/terms?itemNumber='+encodeURIComponent(itemNumber);
			 }
           }
            else{
              this.addToCartAndRedirect(addRenewMemberhsipToCartUrl, isUpgrade);
            }


        } else {
          console.error('MembershipRenewUpgradeStatic object does not exist.');
        }
      
    },

    /**
     * Calls AjaxManageShoppingCart and redirects to appropriate page
     * @param  {String} addToCartUrl URL to call
     * @return void
     */
    addToCartAndRedirect: function(addToCartUrl, isUpgrade) {
      let isCartEmpty = this.isCartEmpty();
      let requestFromPostLockdownPage = $('#membership-card-info-post-lockdown').length > 0;
      
      if (addToCartUrl) {
        addToCartUrl += '&unverifiedRenew=true';
        
        if (requestFromPostLockdownPage) {
        	COSTCO.Checkout.ajax_update_state({
                method: 'POST',
                url: addToCartUrl,
                dataType: 'json',
                ajax_update_post_done: function(data, textStatus, jqXHR, options) {
                	COSTCO.util.notification.clearNotification('#notification-message');
                  if (data.error.application.length > 0) {
                	  COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], false, '#notification-message');
                	  COSTCO.RenewMembership.revertRadioSelection(isUpgrade);
                	  
                  }
                }
              });
        } else {
	        COSTCO.util.ajax({
	          type: 'POST',
	          url: addToCartUrl,
	          dataType: 'json',
	          done: function(data) {
	        	  let errorObject = !$.isEmptyObject(data.orderErrMsgObj) ? data.orderErrMsgObj : !$.isEmptyObject(data.errorMessage) ? data.errorMessage : '';
	        	  
	        	  if (errorObject) {
	        		  COSTCO.util.notification.clearNotification('#error-message-placeholder');
	        		  COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [errorObject], false, '#error-message-placeholder', 'span');
	        		  $('.order-ajax').removeClass('ajax-busy');
	        	  } else {
	        		  if ($('#isBDAppVar').val() === 'BD') {
	        			  if (isCartEmpty) {
		        			  document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
			        	  } else {
			        		  document.location.href = '/CheckoutCartView?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
			        	  }
	        		  } else {
	        			  document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	        		  }
	        	  }
	          },
	          timeout: wcs.ajaxTimeout,
	          fail: function(x, t, m) {
	            $('.order-ajax').removeClass('ajax-busy');
	            if (t === 'timeout') {
	              console.error('Error AJAX timeout.');
	            } else {
	              console.error('Unexpected AJAX error.');
	            }
	          },
	        });
        }
      } else {
        console.error('Membership not added to cart.');
      }
    },
    /**
     * [secondaryValidationForm object for secondary validation form handling]
     * @type {Object}
     */
    secondaryValidationForm: {

      getForm: function() {
        return $('#SecondaryValidationForm');
      },

      inputRules: function() {
        let rules = {};

        rules.usersAnswer = {
          required: true,
          messages: {
            required: messages.JS_VALID_REQUIRED,
          },
        };

        rules.usersFirstNameAnswer = {
          required: true,
          messages: {
            required: messages.JS_VALID_REQUIRED,
          },
        };

        rules.usersLastNameAnswer = {
          required: true,
          messages: {
            required: messages.JS_VALID_REQUIRED,
          },
        };

        rules.postalCode = {
          required: true,
          messages: {
            required: messages.JS_VALID_REQUIRED,
          },
        };

        rules.employeeDate = {
          required: true,
          checkDate: true,
          checkIsDateInFuture: true,
          messages: {
            checkDate: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_VALID_DATE,
            required: messages.JS_VALID_REQUIRED,
            checkIsDateInFuture: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_PAST_DATE
          },
        };

        return rules;
      },
      /**
       * validates Secondary Validation Form
       * @return {Boolean} if form is valid or not
       */
      validateForm: function() {
        let $form = MembershipValidation.secondaryValidationForm.getForm();
        $form.validate({
          errorPlacement: function(error, element) {
            if (element.is(':radio')) {
              error.appendTo(element.parents('.control-group'));
            } else {
              error.insertAfter(element);
            }
          },
        });
        $.validator.addMethod('checkDate', function(value, element) {
          return this.optional(element) || (/^(1[0-2]|0[1-9]|\d)\/(\d{2})$/).test(value);
        });
        $.validator.addMethod("checkIsDateInFuture", function(value, element ) {
          let isDateInFuture = false;
          let enteredMonth = parseInt(value.split('/')[0]);
          let enteredYear = parseInt(value.split('/')[1]);
          let now = new Date();
          let currentMonth = parseInt((now.getMonth() + 1).toString());
          let currentYear = parseInt(now.getFullYear().toString().substr(-2));
          if (enteredYear == currentYear && enteredMonth > currentMonth) {
            isDateInFuture = true;
          }
          return isDateInFuture ? false : true;
        });

        let actionForm = $('#action')[0].value;
        if (actionForm === 'primary_member_postal_code' || actionForm === 'business_postal_code') {
          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().postalCode);
        } else if (actionForm === 'employee_start_date') {
          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().employeeDate);
        } else if (actionForm === 'employee_first_last_name') {
          $form.find('[name="usersFirstNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersFirstNameAnswer);
          $form.find('[name="usersLastNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersLastNameAnswer);

          $('#usersAnswer')[0].value = $form.find('[name="usersFirstNameAnswer"]').val() + '|' + $form.find('[name="usersLastNameAnswer"]').val();
        } else if (actionForm === 'employee_last_name') {
          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersAnswer);
        }
        return $form.valid();
      },
      /**
       * Submits Secondary Validation Form
       * @return void
       */
      submitForm: function() {
        if (MembershipValidation.secondaryValidationForm.validateForm()) {
          MembershipValidation.secondaryValidationForm.getForm().submit();
        }
      },
    },
    /**
     * [addMembershipForm Object for Add membership Form handling]
     * @type {Object}
     */
    addMembershipForm: {
      getForm: function() {
        return $('#AddMembershipForm');
      },
      validateForm: function() {
        let $form = MembershipValidation.addMembershipForm.getForm();

        $.validator.addMethod('costcoMembership', function(value, element) {
          return (/^\d{12,16}$/.test(value));
        }, messages.ERR_INVALID_MEMBERSHIP_NO);

        $form.validate({
          rules: {
            membershipId: {
              required: true,
              costcoMembership: true,
            },
            lastName: {
              required: true,
            },
          },
          messages: {
            membershipId: {
              required: messages.JS_VALID_REQUIRED,
              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO,
            },
            lastName: {
              required: messages.JS_VALID_REQUIRED,
            },
          },
        });
        return $form.valid();
      },
      /**
       * Submits Add Membership form
       * @return void
       */
      submitForm: function() {
    	sessionStorage.removeItem("changeValidationFlag");
        if (MembershipValidation.addMembershipForm.validateForm()) {
           // verifyme validation
	       if ((typeof verifyMeFlowEnabled !== 'undefined' && verifyMeFlowEnabled === true  && wcs.storeId !== 'undefined' && wcs.storeId === '10302')
	    		&& $("#membershipNumber").parent()[0] !== 'undefined' && $("#membershipNumber").parent()[0] !== undefined && (/^$/.test($('#membershipNumber').val()) || !/^\d{12,12}$/.test($('#membershipNumber').val()))) {
	    	   // verify me flow enabled and CA and membership number is invalid	    	    
	        	$("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
	            $("#membershipNumber")[0].classList.add("highlightError");
	            $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_INVALID_MEMBERSHIP_NO;
	            $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';
	       }else{
	    	   MembershipValidation.addMembershipForm.getForm().submit();
	       }
          
        } else if(memberOnlyFeatureEnabled !== undefined && memberOnlyFeatureEnabled === true) {
        	$('#membershipId label.error').insertAfter( $('#membershipId label.error').next());
        }
      },
    },

    /**
     * Mask input fields
     */
    maskInputs: function() {
      let $form = MembershipValidation.secondaryValidationForm.getForm();
      if ($form.length > 0) {
        $($form).find('#employeeStartDate').mask('00/00', {
          placeholder: 'MM/YY',
        });

        // Set initial mask input.
        if (COSTCO.CAddressForm.isUS()) {
          $($form).find('#postalCode').unmask().mask('00000-0000');
        } else {
          $($form).find('#postalCode').unmask().mask('S0S 0S0');
        }

        // Enable both CA postal-code mask and US ZIP-code mask depending on first character,
        // as US members must be able to link membership on CA site and vice versa.
        // CA postal-code starts with a letter, US ZIP-code starts with a digit.
        $($form).find('#postalCode').keypress(function(event) {
          if ($($form).find('#postalCode').val().length == 0) {
            if (/[a-zA-Z]/.test(event.key)) {
              $($form).find('#postalCode').unmask().mask('S0S 0S0');
            } else if (/[0-9]/.test(event.key)) {
              $($form).find('#postalCode').unmask().mask('00000-0000');
            } else {
              $($form).find('#postalCode').val('');
                return false;
            }
          }
        });
      }
    },

    /**
     * Checks if cart is empty.
     * @return {Boolean}
     *
     */
    isCartEmpty: function() {
      let cartEmpty = true;
      let cartCookie = $.cookie('cartCountCookie');
      if (cartCookie != null && cartCookie != 'undefined') {
        if (cartCookie > 0) {
          cartEmpty = false;
        }
      }
      return cartEmpty;
    },

    /**
     * Opens 'Upgrade Membership' dialog modal.
     * @return {void}
     */
    openUpgradeMembershipModal: function(membershipType) {
    
      let fromPage =  $('#fromPage').val();
      if(fromPage === undefined){
    	 fromPage = '';
      }
    
      let modalSettings = {
        dialogclasses: '',
        title: messages.MEMBERSHIP_VALIDATION_UpgradeMembershipModal_Title,
        body: COSTCO.util.tmpl('tmpl_upgrade_membership', {}),
        primary: messages.MEMBERSHIP_VALIDATION_Expired_Upgrade_Button_Text,
        secondary: messages.MEMBERSHIP_VALIDATION_Expired_Renew_Only_Button_Text,
        primary_event: function() {
          COSTCO.MembershipValidation.renewMembership(membershipType, false, true, fromPage);
          COSTCO.dialog.close();
        },
        secondary_event: function() {
          COSTCO.MembershipValidation.renewMembership(membershipType, false, false, fromPage);
          COSTCO.dialog.close();
        },
        onclose: function() {
        	if (typeof isDmcPage !== 'undefined' && isDmcPage) {
        		window.location='/DMCCheck?action=renewal&renewCanceled=true';
        	}
        },
        onshown: function() {},
      };
      COSTCO.dialog.showModal(modalSettings);
    },

    /**
     * Shows last name / zip code form to validate user for editing membership info
     * If user entered valid last name & zip code - save info as flag
     */
    showValidationPrescreen: function() {
      let settings = {};
      if ($("#maxAttemptMemberAccountReached").val() === "false") {
        settings = {
          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
          body: COSTCO.util.tmpl("tmpl_membership_validate_prescreen", {}),
          primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
          secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
          dialogclasses: "modal-dialog-membership verify-membership-dialog",
          primary_button_style: "rounded",
          secondary_button_style: "rounded",
          primary_event: () => {
            if (COSTCO.MemberVerification.validateZipCodeForm($("#MemberValidationForm"))) {
              let url = COSTCO.util.makeUrl('/AjaxAccountAutoRenewMembershipValidationCmd', {
                lastName: $('#questionLastName').val(),
                zipCode: $('#questionZip').val(),
              });

              COSTCO.MemberVerification.submitRequest(url)
                .then((data) => {
                  $('#questionLastName').val('');
                  $('#questionZip').val('');
                  $('#labelQuestionLastName').removeClass('active');
                  $('#labelQuestionZip').removeClass('active');
                  if (data.memberAccountRecordCheckMaxAttempsReached == 'true') {
                  	let newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
                      COSTCO.dialog.updateModal(newSettings);
                      $("#maxAttemptMemberAccountReached").val("true");
                  } else if (data.memberAccountRecordMatch == 'true') {
                    let newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_success");
                    COSTCO.dialog.updateModal(newSettings);
                    sessionStorage.setItem("changeValidationFlag", true);
                  } else {
                    $("#MemberValidationForm .notification").removeClass("hidden");
                  }
                });
            }
          },
          secondary_event: () => {
            COSTCO.dialog.close();
          },
          close: () => {
            COSTCO.dialog.close();
          },
          afterclose: () => {
            $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
            $('#costcoModalBtn2').removeClass('primary-button-v2');
            $('.costcoModalBtn1').removeClass('secondary-button-v2');
          },
          onshown: () => {
            COSTCO.util.maskMembershipInput();
          },
        };
      } else {
        settings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
      }
      COSTCO.dialog.createExtDialogBox(settings);
    },

    /**
     * Show different info on modal after member account check
     * @param tmplName - template name to be loaded in modal body.
     * @param tmplParam - parameters to be loaded for template. Default is empty.
     */
    updateValidationModal: function (tmplName, tmplParam = {}) {
      return {
        title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
        body: COSTCO.util.tmpl(tmplName, tmplParam),
        primary: messages.CLOSE,
        primary_button_style: "rounded",
        setHalfButtons: true,
        primary_event: () => {
          COSTCO.dialog.close();
        },
        afterclose: () => {
          $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
          $('#costcoModalBtn2').removeClass('primary-button-v2');
          $('.costcoModalBtn1').removeClass('secondary-button-v2');
        },
      };
    },
  };

  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.MembershipValidation = MembershipValidation;

  return MembershipValidation;
});



// WEBPACK FOOTER //
// ./js/account/membership-validation.js